// Login component
//
// Purpose:
// - Present a simple login prompt and delegate actual sign-in behavior to auth helpers.
// - Keep inline styles minimal and descriptive so the UI is easy to maintain.

import * as React from 'react';
import { login } from '../auth/msal';

interface Props { error?: string|null; }

export default function Login({ error }: Props){
  async function handleLogin(){
    try { await login(true); } catch(e){ console.error(e); }
  }
  return (
    <div className="login-container">
      <div className="login-header">
        <h2 className="login-title"><b>Archive in the Cloud</b></h2>
        <p className="login-subtext">Sign in to continue</p>
      </div>
      <button onClick={handleLogin} className="login-button">Login with a Microsoft account</button>
      {error && <div className="login-error">{error}</div>}
      {!error && <div className="login-muted">Your email must be registered by an administrator.</div>}
    </div>
  );
}
